import { render } from "./MailHeader.vue?vue&type=template&id=a31e0e84&ts=true"
import script from "./MailHeader.vue?vue&type=script&lang=ts"
export * from "./MailHeader.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__